import request from '@/utils/request'

export function getList(data) {
    return request({
        url: '/backend/activity/camp/list',
        method: 'post',
        data: data
    })
}

export function getInfo(data) {
    return request({
        url: '/backend/activity/camp/info',
        method: 'post',
        data: data
    })
}

export function createInfo(data) {
    return request({
        url: '/backend/activity/camp/create',
        method: 'post',
        data: data
    })
}

export function updateInfo(data) {
    return request({
        url: '/backend/activity/camp/update',
        method: 'post',
        data: data
    })
}

export function savePageElementInfo(data) {
    return request({
        url: '/backend/activity/camp/savePageElementInfo',
        method: 'post',
        data: data
    })
}

export function savePageIdInfo(data) {
    return request({
        url: '/backend/activity/camp/savePageIdInfo',
        method: 'post',
        data: data
    })
}

export function updateOnline(data) {
    return request({
        url: '/backend/activity/camp/updateOnline',
        method: 'post',
        data: data
    })
}

export function deleteActivityInfo(data) {
    return request({
        url: '/backend/activity/camp/deleteActivityInfo',
        method: 'post',
        data: data
    })
}

export function orderList(data) {
    return request({
        url: '/backend/activity/camp/orderList',
        method: 'post',
        data: data
    })
}

export function typeList(data) {
    return request({
        url: '/backend/activity/camp/typeList',
        method: 'post',
        data: data
    })
}

export function typeInfo(data) {
    return request({
        url: '/backend/activity/camp/typeInfo',
        method: 'post',
        data: data
    })
}

export function createCampType(data) {
    return request({
        url: '/backend/activity/camp/createCampType',
        method: 'post',
        data: data
    })
}

export function updateCampType(data) {
    return request({
        url: '/backend/activity/camp/updateCampType',
        method: 'post',
        data: data
    })
}